<template>
    <b-card :show-footer-line="true">
        <b-card-title class="text-uppercase text-muted mb-0" v-if="title">
            {{ title }}
        </b-card-title>
        <b-container fluid>
            <b-row no-gutters>
                <b-col cols="6">
                    <div class="justify-content-center align-items-center">
                        <h4>
                            <b-badge pill variant="primary">{{
                                count || 0
                            }}</b-badge>
                        </h4>
                    </div>
                </b-col>

                <b-col>
                    <div class="h2 mb-0">
                        <b-icon
                            :icon="iconName"
                            class="rounded-circle p-2"
                            :class="iconColor"
                            variant="light"
                            font-scale="2"
                        ></b-icon>
                    </div>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col>
                    <span class="font-weight-bold mb-0" v-if="subTitle">
                        {{ subTitle }}
                    </span>
                </b-col>
            </b-row>
        </b-container>
    </b-card>
</template>
<script>
export default {
    name: 'stats-card',
    props: ['type', 'count', 'iconName', 'iconColor', 'title', 'subTitle'],
}
</script>
<style></style>
